export enum FormType {
  COMPOSITE = 'composite',
  LIST = 'list',
  FIELD_GROUP = 'field_group',
}

export default FormType
